<template>
  <lp-input
    :model-value="urlValue"
    :status="isValid ? 'neutral' : 'danger'"
    :message="message || (isValid ? '' : 'Email address is invalid')"
    :preview="preview"
    @update:model-value="updateModelValue"
  />
</template>

<script lang="ts">
export default {
  name: 'lp-email-input',
}
</script>

<script setup lang="ts">
import { computed } from 'vue'

const emit = defineEmits(['update:model-value'])

interface Props {
  modelValue: string | null
  message?: string | null
  preview?: boolean | null
}

const props = withDefaults(defineProps<Props>(), {
  modelValue: null,
  message: null,
  preview: false,
})

const urlValue = computed(() => props.modelValue)

const isValid = computed(() => {
  const pattern = new RegExp(
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  ) // fragment locator
  return urlValue.value === '' || urlValue.value === null
    ? true
    : !!pattern.test(urlValue.value)
})
const updateModelValue = (value: string) => {
  emit('update:model-value', value)
}
</script>
